import React from "react";
import HexContentBox from "../../../../../components/HexContentBox";
import HexTitle from "../../../../../components/HexTitle";
import ImageRowContainer from "../../../../../components/ImageRowContainer";
import SupplierRating from "../../../../Home/Components/SupplierRating";
import { setListColSize1, setListColSize2 } from "../supplier-review-utils";

const List = ({ reviewList, resizeWidth }) => {
  const list = reviewList.map((item, index) => {
    const { id, imgRow, rating, review, dateTime, reviewClass } = item;

    return (
      <li key={id} className={`review-list-item review-list-item${index}`}>
        <div className="review-list-content">
          <ImageRowContainer
            className={`reivew-img-row ${reviewClass || ''}`}
            titleClass="font-14-normal-400-lh-14 primary-color"
            props={{ ...imgRow }}
            colsize1={setListColSize1(resizeWidth)}
            colsize2={setListColSize2(resizeWidth)}
          />
          <SupplierRating
            rating={rating}
            decimalRating={true}
            hideTextRating={true}
          />
          <HexContentBox
            paragraph={review}
            className="font-14-normal-400-lh-14 primary-color mt-10 mb-10"
          />
          <HexTitle
            title={dateTime}
            className="font-12-normal-400-lh-14 reivew-time-date"
          />
        </div>
      </li>
    );
  });

  return <ul className="reviews-list">{list}</ul>;
};

export default List;
